// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

//         this.addEventListener('product-info:loaded', ({ target }) => {
//           target.addPreProcessCallback(this.preprocessHTML.bind(this));
//         });
//       }

//       hide(preventFocus = false) {
//         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//         this.modalContent.innerHTML = '';

//         if (preventFocus) this.openedBy = null;
//         super.hide();
//       }

//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');

//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             const productElement = responseHTML.querySelector('product-info');

//             this.preprocessHTML(productElement);
//             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }
//             if (window.ProductModel) window.ProductModel.loadShopifyXR();

//             super.show(opener);
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       preprocessHTML(productElement) {
//         productElement.classList.forEach((classApplied) => {
//           if (classApplied.startsWith('color-') || classApplied === 'gradient')
//             this.modalContent.classList.add(classApplied);
//         });
//         this.preventDuplicatedIDs(productElement);
//         this.removeDOMElements(productElement);
//         this.removeGalleryListSemantic(productElement);
//         this.updateImageSizes(productElement);
//         this.preventVariantURLSwitching(productElement);
//       }

//       preventVariantURLSwitching(productElement) {
//         productElement.setAttribute('data-update-url', 'false');
//       }

//       removeDOMElements(productElement) {
//         const pickupAvailability = productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();

//         const productModal = productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();

//         const modalDialog = productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }

//       preventDuplicatedIDs(productElement) {
//         const sectionId = productElement.dataset.section;

//         const oldId = sectionId;
//         const newId = `quickadd-${sectionId}`;
//         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
//         Array.from(productElement.attributes).forEach((attribute) => {
//           if (attribute.value.includes(oldId)) {
//             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
//           }
//         });

//         productElement.dataset.originalSection = sectionId;
//       }

//       removeGalleryListSemantic(productElement) {
//         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;

//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }

//       updateImageSizes(productElement) {
//         const product = productElement.querySelector('.product');
//         const desktopColumns = product?.classList.contains('product--columns');
//         if (!desktopColumns) return;

//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;

//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }

//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }
//     }
//   );
// }

// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

//         this.addEventListener('product-info:loaded', ({ target }) => {
//           target.addPreProcessCallback(this.preprocessHTML.bind(this));
//         });
//       }

//       hide(preventFocus = false) {
//         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//         this.modalContent.innerHTML = '';

//         if (preventFocus) this.openedBy = null;
//         super.hide();
//       }

//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');

//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             const productElement = responseHTML.querySelector('product-info');

//             this.preprocessHTML(productElement);
//             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }
//             if (window.ProductModel) window.ProductModel.loadShopifyXR();

//             super.show(opener);
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       preprocessHTML(productElement) {
//         productElement.classList.forEach((classApplied) => {
//           if (classApplied.startsWith('color-') || classApplied === 'gradient')
//             this.modalContent.classList.add(classApplied);
//         });
//         this.preventDuplicatedIDs(productElement);
//         this.removeDOMElements(productElement);
//         // Shoe Street: removeGalleryListSemantic() intentionally NOT called here.
//         // It sets role="presentation" on the slider <ul> + <li> elements which
//         // breaks Dawn's slider-component scroll behaviour inside the modal.
//         // this.removeGalleryListSemantic(productElement);
//         this.updateImageSizes(productElement);
//         this.preventVariantURLSwitching(productElement);

//         // Shoe Street: initialise dot indicators after HTML is injected
//         window.requestAnimationFrame(() => this.initGalleryDots(productElement));
//       }

//       initGalleryDots(productElement) {
//         const sliderList = productElement.querySelector('[id^="Slider-Gallery"]');
//         if (!sliderList) return;

//         const slides = Array.from(sliderList.querySelectorAll('.product__media-item'));
//         if (slides.length < 2) return;

//         // Create dot container
//         const dotsWrap = document.createElement('div');
//         dotsWrap.className = 'ss-qv-dots no-js-hidden';
//         dotsWrap.setAttribute('aria-hidden', 'true');

//         slides.forEach((_, idx) => {
//           const dot = document.createElement('button');
//           dot.className = 'ss-qv-dot' + (idx === 0 ? ' is-active' : '');
//           dot.type = 'button';
//           dot.setAttribute('aria-label', `Image ${idx + 1}`);
//           dot.addEventListener('click', () => {
//             // Scroll to the matching slide
//             const target = slides[idx];
//             sliderList.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
//           });
//           dotsWrap.appendChild(dot);
//         });

//         // Insert dots right after the slider-component (GalleryViewer)
//         const sliderComponent = productElement.querySelector('[id^="GalleryViewer"]');
//         if (sliderComponent && sliderComponent.parentNode) {
//           sliderComponent.parentNode.insertBefore(dotsWrap, sliderComponent.nextSibling);
//         }

//         // Keep dots in sync with scroll
//         const updateDots = () => {
//           const scrollLeft = sliderList.scrollLeft;
//           const slideWidth = sliderList.offsetWidth;
//           const activeIdx = Math.round(scrollLeft / slideWidth);
//           dotsWrap.querySelectorAll('.ss-qv-dot').forEach((dot, idx) => {
//             dot.classList.toggle('is-active', idx === activeIdx);
//           });
//         };

//         sliderList.addEventListener('scroll', updateDots, { passive: true });
//       }

//       preventVariantURLSwitching(productElement) {
//         productElement.setAttribute('data-update-url', 'false');
//       }

//       removeDOMElements(productElement) {
//         const pickupAvailability = productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();

//         const productModal = productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();

//         const modalDialog = productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }

//       preventDuplicatedIDs(productElement) {
//         const sectionId = productElement.dataset.section;

//         const oldId = sectionId;
//         const newId = `quickadd-${sectionId}`;
//         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
//         Array.from(productElement.attributes).forEach((attribute) => {
//           if (attribute.value.includes(oldId)) {
//             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
//           }
//         });

//         productElement.dataset.originalSection = sectionId;
//       }

//       removeGalleryListSemantic(productElement) {
//         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;

//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }

//       updateImageSizes(productElement) {
//         const product = productElement.querySelector('.product');
//         const desktopColumns = product?.classList.contains('product--columns');
//         if (!desktopColumns) return;

//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;

//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }

//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }
//     }
//   );
// }

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      /* ============================= */
      /* SHOW MODAL */
      /* ============================= */
      show(opener) {

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // IMPORTANT: initialise AFTER content is injected
            requestAnimationFrame(() => {
              this.initGalleryDots();
              this.initGalleryArrows();
              this.initMobileThumbnails()
            });

            super.show(opener);
            
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      /* ============================= */
      /* HIDE MODAL */
      /* ============================= */
      hide(preventFocus = false) {
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      /* ============================= */
      /* PREPROCESS HTML */
      /* ============================= */
      preprocessHTML(productElement) {
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      /* ============================= */
      /* DOTS */
      /* ============================= */
      initGalleryDots() {
        const sliderList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!sliderList) return;

        const slides = Array.from(
          sliderList.querySelectorAll('.product__media-item')
        );

        if (slides.length < 2) return;

        // Remove old dots if reopening modal
        const oldDots = this.modalContent.querySelector('.ss-qv-dots');
        if (oldDots) oldDots.remove();

        const dotsWrap = document.createElement('div');
        dotsWrap.className = 'ss-qv-dots';

        slides.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.className = 'ss-qv-dot' + (index === 0 ? ' is-active' : '');
          dot.type = 'button';

          dot.addEventListener('click', () => {
            sliderList.scrollTo({
              left: slides[index].offsetLeft,
              behavior: 'smooth',
            });
          });

          dotsWrap.appendChild(dot);
        });

        sliderList.after(dotsWrap);

        const updateDots = () => {
          const activeIndex = Math.round(
            sliderList.scrollLeft / sliderList.offsetWidth
          );

          dotsWrap.querySelectorAll('.ss-qv-dot').forEach((dot, idx) => {
            dot.classList.toggle('is-active', idx === activeIndex);
          });
        };

        sliderList.addEventListener('scroll', updateDots, { passive: true });
      }

      /* ============================= */
      /* ARROWS */
      /* ============================= */
      initGalleryArrows() {
        const sliderList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!sliderList) return;

        const slides = Array.from(
          sliderList.querySelectorAll('.product__media-item')
        );

        const prevBtn = this.modalContent.querySelector('.prev-btn');
        const nextBtn = this.modalContent.querySelector('.next-btn');

        if (!prevBtn || !nextBtn) return;

        const getActiveIndex = () =>
          Math.round(sliderList.scrollLeft / sliderList.offsetWidth);

        prevBtn.onclick = () => {
          const newIndex = Math.max(0, getActiveIndex() - 1);
          sliderList.scrollTo({
            left: slides[newIndex].offsetLeft,
            behavior: 'smooth',
          });
        };

        nextBtn.onclick = () => {
          const newIndex = Math.min(
            slides.length - 1,
            getActiveIndex() + 1
          );
          sliderList.scrollTo({
            left: slides[newIndex].offsetLeft,
            behavior: 'smooth',
          });
        };
      }

      // thumbnail code start
/* ============================= */
/* MOBILE THUMBNAILS */
/* ============================= */
initMobileThumbnails() {
  if (window.innerWidth > 749) return;

  const sliderList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
  if (!sliderList) return;

  const slides = Array.from(
    sliderList.querySelectorAll('.product__media-item img')
  );

  if (slides.length < 2) return;

  // Remove old thumbnails if reopening modal
  const oldThumbs = this.modalContent.querySelector('.ss-qv-thumbs');
  if (oldThumbs) oldThumbs.remove();

  const thumbsWrap = document.createElement('div');
  thumbsWrap.className = 'ss-qv-thumbs';

  slides.forEach((img, index) => {
    const thumb = document.createElement('img');
    thumb.src = img.src;
    thumb.className = 'ss-qv-thumb' + (index === 0 ? ' is-active' : '');
    thumb.setAttribute('data-index', index);

    thumb.addEventListener('click', () => {
      sliderList.scrollTo({
        left: sliderList.offsetWidth * index,
        behavior: 'smooth',
      });
    });

    thumbsWrap.appendChild(thumb);
  });

  sliderList.after(thumbsWrap);

  // Sync active thumbnail on scroll
  sliderList.addEventListener(
    'scroll',
    () => {
      const activeIndex = Math.round(
        sliderList.scrollLeft / sliderList.offsetWidth
      );

      thumbsWrap.querySelectorAll('.ss-qv-thumb').forEach((thumb, idx) => {
        thumb.classList.toggle('is-active', idx === activeIndex);
      });
    },
    { passive: true }
  );
}

      //thumbnail code end

      /* ============================= */
      /* HELPERS */
      /* ============================= */
      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement.querySelector('pickup-availability')?.remove();
        productElement.querySelector('product-modal')?.remove();
        productElement
          .querySelectorAll('modal-dialog')
          ?.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML =
          productElement.innerHTML.replaceAll(sectionId, newId);

        Array.from(productElement.attributes).forEach((attr) => {
          if (attr.value.includes(sectionId)) {
            productElement.setAttribute(
              attr.name,
              attr.value.replace(sectionId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }
    }
  );
}